import type { RouteProps } from 'react-router';

import { getStatsigClientInstance } from '@coursera-web/statsig';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import NotFound from 'bundles/phoenix/components/NotFound';

type GetComponent = Required<RouteProps>['getComponent'];

const gateOnUnifiedEnterprise =
  (getComponent: GetComponent): GetComponent =>
  (nextState, cb) => {
    const isOrgScopedHomeEnabled = GrowthDiscoveryEpicClient.preview('orgScopedHome');
    const showUnifiedSearch = getStatsigClientInstance()
      .getLayer('enterprise-search-layer')
      .get('unifiedEnterpriseSearch', false);

    if (!isOrgScopedHomeEnabled && !showUnifiedSearch) {
      cb(null, NotFound);
      return;
    }
    getComponent(nextState, cb);
  };

export default gateOnUnifiedEnterprise;
